import TextInput from "../../../form/TextInput";
import React from "react";
import Select from "../../../form/Select";

export default (propsTop) => {
    const {props, state, parent} = propsTop;
    const {hidden, labels, pool, operationitems, actionButtons} = props;
    return (hidden || []).indexOf("discount") === -1 && <div className="row form-row">
        <div className="col-sm-12">
            <Select
                disabled={props.isLoading}
                value={(props.values.xtradata || {}).vat}
                label="Áfa"
                component="vatrate"
                isClearable={true}
                storeType="local"
                filter={[{field: "rate", value: 0}]}
                objectValue={false}
                saveChanges={(field, vat) => props.setFieldValue("xtradata.vat", vat)}
            />
        </div>
    </div>;
}